<msf-summary-wrapper
  title="{{ 'Crop identification' | translate }}"
  [items]="MENU_ITEMS | menuChildren:MenuItemType.CropIdentification"
  leftSize="4"
  rightSize="8">
  <div
    right
    #right>
    <div class="summary-card mt-4">
      <div class="flex justify-content-between align-items-center mb-4">
        <h2 class="summary-title mb-0">{{ "Summary information" | translate }}</h2>
        <p-button
          label="{{ 'Export' | translate }}"
          icon="pi pi-plus"
          styleClass="p-button-outlined p-button-secondary bg-black text-white"
          (onClick)="onExport()"></p-button>
      </div>

<!--      <p-table-->
<!--        [value]="summaryData"-->
<!--        [tableStyle]="{ 'min-width': '50rem' }"-->
<!--        styleClass="p-datatable-gridlines custom-table">-->
<!--        <ng-template pTemplate="header">-->
<!--          <tr>-->
<!--            <th>{{ "Model" | translate }}</th>-->
<!--            <th>{{ "Module" | translate }}</th>-->
<!--            <th>{{ "Version" | translate }}</th>-->
<!--            <th>{{ "Description" | translate }}</th>-->
<!--            <th>{{ "Last Run Date" | translate }}</th>-->
<!--            <th>{{ "Status" | translate }}</th>-->
<!--            <th>{{ "Result" | translate }}</th>-->
<!--          </tr>-->
<!--        </ng-template>-->
<!--        <ng-template-->
<!--          pTemplate="body"-->
<!--          let-item>-->
<!--          <tr>-->
<!--            <td>{{ item.model }}</td>-->
<!--            <td>{{ item.module }}</td>-->
<!--            <td>{{ item.version }}</td>-->
<!--            <td>{{ item.description }}</td>-->
<!--            <td>{{ item.lastRunDate }}</td>-->
<!--            <td>-->
<!--              <span-->
<!--                class="status-badge"-->
<!--                [ngClass]="{-->
<!--                  active: item.status === 'Active',-->
<!--                  processing: item.status === 'Processing',-->
<!--                  badge: item.status === 'Badge',-->
<!--                }">-->
<!--                {{ item.status | translate }}-->
<!--              </span>-->
<!--            </td>-->
<!--            <td>-->
<!--              <span [ngClass]="{ 'badge-blue': item.result === 'Badge' }">-->
<!--                {{ item.result }}-->
<!--              </span>-->
<!--            </td>-->
<!--          </tr>-->
<!--        </ng-template>-->
<!--      </p-table>-->

      <div class="mt-3">
        <small>{{ "Information Schema" | translate }}</small>
      </div>
    </div>
  </div>
</msf-summary-wrapper>
